import React from 'react';
import { Tooltip } from '@mui/material';
import { ReactComponent as DetailsIcon } from 'new/components/icons/fi-rr-info.svg';
import { DefaultTooltipPopperProps } from 'js/components/elements/mui/Tooltip';

interface DetailsIconButtonProps {
  onClick: (event?: any) => void;
  className?: string;
}

const btn_style = {
  width: 16,
  height: 16,
  padding: 0,
  margin: 0,
  border: 'none',
  background: 'transparent',
};

export function DetailsIconButton(props: DetailsIconButtonProps) {
  return (
    <button role="button" style={btn_style} aria-label="Details" onClick={props?.onClick}>
      <Tooltip
        title="Details"
        // @ts-ignore-next-line
        interactive="true"
        placement="bottom"
        tooltipTheme="dark"
        PopperPros={DefaultTooltipPopperProps}
      >
        <DetailsIcon width={16} height={16} className={props?.className} />
      </Tooltip>
    </button>
  );
}
